export const EventPageTabs = {
  DETAIL: 'detail',
  CONVERSATION: 'conversation',
};

export const TrackingSourceByTab = {
  [EventPageTabs.DETAIL]: 'event_details_page',
  [EventPageTabs.CONVERSATION]: 'event_conversation_page',
  QUESTION_MODAL: 'ask_a_question_modal',
};

export const EVENT_TAB_PARAM = 'tab';
